import React from "react"

import {
  styled,
  Typography,
  useTheme
} from "@mui/material"

import HKVLink from "../components/HKVLink"

import { useLocation } from "react-router-dom"
import { capitalizeFirstLetter } from "../lib/utils"

const StyledNav = styled("nav", {
  shouldForwardProp: (prop) => prop !== "sticky",
})(({ theme, sticky }) => {
  return {
    display: "block",
    flexBasis: 240,
    ...sticky && {
      position: "sticky",
      height: "fit-content",
      top: theme.spacing(1)
    },
    "& .subnav": {
      listStyle: "none",
      margin: 0,
      paddingLeft: theme.spacing(3)
    },
    "& .subnav-item": {
      listStyle: "none",
      position: "relative"
    },
    "& .subnav-item:not(:last-of-type)::before": {
      content: "' '",
      backgroundColor: theme.palette.grey[400],
      display: "block",
      position: "absolute",
      top: 20,
      bottom: -20,
      left: -15,
      width: 3,
      zIndex: 5
    },
    "& .subnav-item-link": {
      display: "block",
      padding: theme.spacing(1, 0)
    },
    "& .subnav-item-link span": {
      fontSize: theme.typography.pxToRem(18)
    },
    "& .subnav-item-link.current span": {
      color: theme.palette.hemelblauw.main,
      fontWeight: 700
    },
    "& .subnav-item-link::before": {
      content: "' '",
      backgroundColor: theme.palette.grey[400],
      boxShadow: "0 0 2px 2px #fff",
      borderRadius: "100%",
      width: 10,
      height: 10,
      position: "absolute",
      transform: "translateY(9.5px) translateX(-18.5px)",
      zIndex: 10
    },
    "& .subnav-item-link.current::before": {
      backgroundColor: theme.palette.hemelblauw.main
    },
    [theme.breakpoints.down("lg")]: {
      flexBasis: 320
    },
    [theme.breakpoints.down("sm")]: {
      display: "none"
    }
  }
})

const SubNav = (props) => {
  const {
    showCurrentPage = true,
    sticky = false
  } = props

  const location = useLocation()
  const pathNames = location.pathname.split("/").filter(x => x)

  const theme = useTheme()

  return (
    <StyledNav className="page-detail-subnav" sticky={sticky}>
      <ul className="subnav">
        <li className="subnav-item">
          <HKVLink
            to="/"
            className="subnav-item-link"
          >
            <Typography component="span">Home</Typography>
          </HKVLink>
        </li>
        {pathNames.map((pathName, ix) => {
          const isLast = ix === pathNames.length - 1
          const to = `/${pathNames.slice(0, ix + 1).join('/')}`

          const label = capitalizeFirstLetter(pathName?.replaceAll("_", " "))

          if (isLast ? (isLast && showCurrentPage) : true) {
            return <li key={ix} className="subnav-item">
              <HKVLink
                to={to}
                className={isLast && showCurrentPage ? "subnav-item-link current" : "subnav-item-link"}
                sx={{
                  color: isLast && showCurrentPage ? theme.palette.hemelblauw.main : "inherit",
                  fontWeight: isLast && showCurrentPage ? 700 : 400
                }}
              >
                <Typography component="span">{label}</Typography>
              </HKVLink>
            </li>
          }
        })}
      </ul>
    </StyledNav>
  )
}

export default React.memo(SubNav)